import { UsersListType } from 'shared/types';

export const prepareList = (list: UsersListType) => ({
  list: list.items.map((user) => ({
    id: user.id,
    phone: user.phone,
    name: `${user?.last_name ?? '---'} ${user?.first_name ?? '---'} ${user?.middle_name ?? '---'}`,
    city: `${user?.city?.country.name} ${user?.city?.name}`,
    iin: user?.iin ?? '---',
    status: user?.status ? (user?.status === 1 ? 'Активный' : 'Заблокирован') : '---',
  })),
  total: list?.total,
  page: list?.page,
  size: list?.size,
});
